const LS_KEY = "freight_admin_row_notify";

export function readAllRowNotify() {
  try {
    return JSON.parse(localStorage.getItem(LS_KEY) || "{}");
  } catch {
    return {};
  }
}

export function writeRowNotify(rowId, patch) {
  const all = readAllRowNotify();
  all[String(rowId)] = { ...(all[String(rowId)] || {}), ...patch };
  localStorage.setItem(LS_KEY, JSON.stringify(all));
}

export function getRowNotify(rowId) {
  const row = readAllRowNotify()[String(rowId)];
  return {
    wa: row?.wa !== false,
    app: row?.app !== false
  };
}
